angular.module('myApp.offers', ['ngRoute', 'angular-clipboard']).config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/offers', {
		templateUrl: 'components/offers/offers.html',
		controller: 'offersCtrl'
	})
}]).controller('offersCtrl', ['$scope', '$window', '$timeout', function($scope, $window, $timeout) {

	$window.scrollTo(0, 0);
	$scope.supported = false;
	$scope.textToCopy = 'JFC60';
	$scope.textToCopy1 = 'JMK60';
	$scope.textToCopy2 = 'JUGNOO100';
	$scope.textToCopy3 = 'MEALS100';
	$scope.textToCopy4 = 'FT20';
	$scope.textToCopy5 = 'MENUS75';
	$scope.textToCopy6 = 'MENUS100';

	$('.offerButton').tooltip({
		title: "Click! to copy coupon code",
		trigger: "hover"
	});
	$scope.success = function() {};
	$scope.fail = function(err) {
		console.error('Error!', err);
	};

}]);